<template>

    <v-dialog persistent v-model="enable" width="100%">

        <v-card>
            <v-card-title class="d-block">
                <div class="popup-title">
                    <slot name="title"></slot>
                </div>

                <v-icon size="90" class="d-block" color="warning">
                    mdi-timer-sand
                </v-icon>
            </v-card-title>

            <v-card-text>
                <slot></slot>
            </v-card-text>
        </v-card>
    </v-dialog>

</template>

<script>


    export default {
        name: 'WaitingPopupMessage',
        data(){
            return {
                enable: false
            }
        },
        props: {
            showPopup: Boolean
        },
        watch:{
            showPopup(val){
                if(val){
                    this.enable = true
                }else{
                    this.enable = false
                }
            }
        }

    }
</script>


<style scoped lang="scss">

    .container_logo {
        padding: 15px;

        .logo {
            margin: 0 auto;
        }
    }

</style>